export enum OrderJourneyStepKey {
    searchRecommendProducts = "search-recommend-products",
    selectProducts = "select-products",
    addContracts = "add-contracts",
    selectContracts = "select-contracts",
    basketSummary = "basket-summary",
    targetGroup = "target-group",
    recruiterInfo = "recruiter-info",
    postingDetails = "posting-details",
    postingOrganization = "posting-organization",
    postingContactInfo = "posting-contact-info",
    postingWorkingLocation = "posting-working-location",
    postingURLs = "posting-urls",
    contractChannelPostingRequirements = "contract-channel-posting-requirements",
    productChannelPostingRequirements = "product-channel-posting-requirements",
    postingUTMCodes = "posting-utm-codes",
    orderReview = "order-review",
    paymentMethod = "payment-method",
    orderConfirmation = "order-confirmation",
}

export enum OrderJourneyPaymentMethod {
    atsManaged = "ats_managed",
    wallet = "wallet",
    purchaseOrder = "purchase_order",
    directCharge = "direct_charge",
}
